import React from 'react'
import PropTypes from 'prop-types'
import { isNil, isNull } from 'lodash'
import { Button, Col, Form, Row, Radio } from 'antd'
import { useDeepEffect } from '../../../../../utils/hooks'

const ConditionForm = (props) => {
  const { onOk, onCancel, form, formState } = props
  const { getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!isNull(formState) && !isNil(formState)) {
      form.setFieldsValue({
        activityCondition1: formState.activityConditions[0].enabled,
        activityCondition2: formState.activityConditions[1].enabled,
        activityCondition3: formState.activityConditions[2].enabled,
        activityCondition4: formState.activityConditions[3].enabled
      })
    }
  }, [formState])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          ...formState,
          activityConditions: [
            {
              ...formState.activityConditions[0],
              enabled: values.activityCondition1
            },
            {
              ...formState.activityConditions[1],
              enabled: values.activityCondition2
            },
            {
              ...formState.activityConditions[2],
              enabled: values.activityCondition3
            },
            {
              ...formState.activityConditions[3],
              enabled: values.activityCondition4
            }
          ]
        }
        await onOk(data)
        await form.resetFields()
      }
    })
  }

  return (
    <Form name="formBrandActivity" onSubmit={onSubmit} layout="vertical">
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Product ที่รองรับ">
        {getFieldDecorator(`activityCondition1`, { initialValue: true })(
          <Radio.Group>
            <Radio value={true}>ใช่</Radio>
            <Radio value={false}>ไม่ใช่ (คำนวนจากทุก Product)</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Hero ที่รองรับ">
        {getFieldDecorator(`activityCondition2`, { initialValue: true })(
          <Radio.Group>
            <Radio value={true}>ใช่</Radio>
            <Radio value={false}>ไม่ใช่ (คำนวนจากทุกฮีโร่)</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Hero Confirm">
        {getFieldDecorator(`activityCondition3`, { initialValue: true })(
          <Radio.Group>
            <Radio value={true}>ใช่</Radio>
            <Radio value={false}>ไม่ใช่ (คำนวนเมื่อ User ส่งต่อ)</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Form.Item label="แสดงคะแนนของกิจกรรมตามลำดับ">
        {getFieldDecorator(`activityCondition4`, { initialValue: true })(
          <Radio.Group>
            <Radio value={true}>ใช่</Radio>
            <Radio value={false}>ไม่ใช่ (แสดงล่าสุดก่อน)</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Row type="flex" justify="end" gutter={8}>
        <Col>
          <Button onClick={() => onCancel()} key="cancel" type="danger">
            ยกเลิก
          </Button>
        </Col>
        <Col>
          <Button
            name="formBrandActivity"
            key="submit"
            type="primary"
            htmlType="submit">
            บันทึก
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

ConditionForm.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  formState: PropTypes.any.isRequired
}

const WrappedConditionForm = Form.create({
  name: 'ConditionForm'
})(ConditionForm)
export default WrappedConditionForm



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandActivity/BrandActivityForm/ConditionForm/index.js